export default __webpack_public_path__ + "static/media/tpp-desexing-allowance.ed501e4a.svg";